var MinimalTheme = {};

jQuery(window).ready(function(){
  
  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 6000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
});

jQuery(window).load(function(){  

  $("select.loc_on_change").change(function(){
    if($(this).find(":selected").attr("value") == "#") return false;
    window.location = $(this).find(":selected").attr("value");
  });
   
});

jQuery(document).ready(function($){
    
  // force wide nav -->  
  
  // <-- end force wide nav
  
  $(".flyout").hide();

  $("#menu-button").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more, .account-links").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
    $(this).next(".more").find("i").toggleClass("fa-user fa-minus");
  });  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
     
  $("a.fancy").fancybox({
    padding: 0
  });
   
  
  
  MinimalTheme.switchImage = function(newSizedImageSrc, newImage, mainImageDomEl) {
    var largestImage = newSizedImageSrc.replace('_1024x1024', '');
    $(mainImageDomEl)
      .attr('src', newSizedImageSrc)
      .parents('a')
      .attr('href', largestImage);
    
  };
  
  $('#product .thumbs a').click(function(e){
    e.preventDefault();
    var newSizedImageSrc = $(this).attr('href');
    var mainImageDomEl = $('.image.featured img')[0];
    MinimalTheme.switchImage(newSizedImageSrc, null, mainImageDomEl);
  });
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $('li.dropdown').hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  /* Added by Coralwebdesigns */
  
  function mobileLayout() {
  		return $(window).width() < 768;
	}
  
  jQuery(document).on('mouseover','.popup_cart',function(){ 
    if(mobileLayout())
    {
      return true;
    }
    jQuery(this).css({'background':'none repeat scroll 0 0 #ededed'});
    jQuery(this).find('a').css('color','#444');
    jQuery('.custom_view_cart').css('display','block');    
  });   
  
  jQuery('body').click(function(e){    
    var c = jQuery(this).attr('class');
    if(c == "custom_view_cart" || c=="popup_cart")
      return;           
	jQuery('.popup_cart').css('background','none');
    jQuery('.custom_view_cart').css('display','none');		
    jQuery('.toolbar a').css('color','#bbb');
    
	});
  
  
  jQuery(document).on('click','#add-to-cart',function(e){
    if(mobileLayout())
    {
      return true;
    }
    e.preventDefault();
    var product = jQuery('#product-select').val();
    var quantity = jQuery('#quantity').val();
    var i=1;
    jQuery(this).val('Adding...').css({'opacity':'0.5'}).attr('disabled','disabled');    
    
    
    jQuery.post('/cart/add.js', {
        quantity: quantity,
        id: product        
    });   
   
   
    var shopifyAjaxStorePageURL = '/search';
    
    $.get(shopifyAjaxStorePageURL, function(data){
        var cartSummarySelector = '.toolbar';
        var $newCartObj = $($.parseHTML(data)).find(cartSummarySelector);
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);                         
      	$('#add-to-cart').val('Add to cart').css({'opacity':'1'}).removeAttr('disabled');	
    });  	
    
  }); 
  
  function popupNewsletter()
  {
     if($(window).scrollTop() + $(window).height() > $(document).height() - 200)
     {
         $(window).unbind('scroll');
         var popup_content = $('#popup_newsletter').html();

         $.fancybox({
             'content': popup_content,
           	'openEffect':'fade'
         });       
     }
  }

	$(window).scroll(popupNewsletter);
  
});